/**
 * Workspace setup hub (2026-09-29). The "Templates", "Notifications" and
 * "Approval workflows" admin sections were static lists; the real screens
 * for these already exist elsewhere, so this points to them.
 */
import { useNavigate } from 'react-router-dom'
import { Bell, Building2, FileText, ListChecks, Upload, Users } from 'lucide-react'
import type { ComponentType } from 'react'

interface Item { title: string; text: string; path: string; icon: ComponentType<{ className?: string }> }

const SETUP_ITEMS: Item[] = [
  { title: 'Project templates', text: 'Reusable project structures with tasks, phases and documents.', path: '/templates', icon: FileText },
  { title: 'Task statuses', text: 'The workflow columns your teams move work through.', path: '/settings/status-sets', icon: ListChecks },
  { title: 'Departments', text: 'Group people and budgets by department.', path: '/departments', icon: Building2 },
  { title: 'Teams', text: 'Delivery teams and who is on them.', path: '/teams', icon: Users },
  { title: 'Notifications', text: 'Which emails and alerts you receive. Each person sets their own.', path: '/settings/notifications', icon: Bell },
  { title: 'Import a spreadsheet', text: 'Bring projects and tasks in from Excel or CSV.', path: '/import', icon: Upload },
]

export function WorkspaceSetupSection() {
  const navigate = useNavigate()
  return (
    <div className="space-y-6">
      <div>
        <h1 className="mb-1 text-2xl text-foreground">Workspace setup</h1>
        <p className="text-muted-foreground">Templates, workflows and structure your teams work within.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {SETUP_ITEMS.map(({ title, text, path, icon: Icon }) => (
          <button key={path} type="button" onClick={() => navigate(path)}
            className="flex min-h-[44px] items-start gap-3 rounded-xl border border-border bg-card p-4 text-left transition-colors hover:bg-muted/50">
            <Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
            <span>
              <span className="block font-medium text-foreground">{title}</span>
              <span className="block text-sm text-muted-foreground">{text}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
